import { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _ from 'lodash';
import omit from 'lodash/omit';

const queryStringToObject = qs => {
  return Object.entries(Object.fromEntries(new URLSearchParams(qs))).reduce(
    (acc, [key, value]) => {
      return { ...acc, [key]: value };
    },
    {}
  );
};

const objectToQueryString = obj => {
  const queryStrings = Object.entries(obj).map(
    ([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
  );
  return queryStrings.join('&');
};

const useQueryStrings = () => {
  const history = useHistory();
  const location = useLocation();
  const [queryParams, setQueryParams] = useState(
    queryStringToObject(location.search)
  );

  useEffect(() => {
    const newQs = queryStringToObject(location.search);
    if (!_.isEqual(newQs, queryParams)) {
      setQueryParams(newQs);
    }
  }, [location.search]);

  useEffect(() => {
    const queryString = objectToQueryString(queryParams);
    if (queryString && location.search.replace('?', '') !== queryString) {
      history.push({ search: queryString });
    }
  }, [queryParams]);

  const updateQueryParam = (key, value) => {
    if (value) {
      setQueryParams(prev => ({ ...prev, [key]: value }));
    } else {
      setQueryParams(prev => omit(prev, key));
    }
  };

  return [queryParams, updateQueryParam];
};

export default useQueryStrings;
